import { ResolutionDetailPage } from '@/components/governance/resolution-detail-page'

export function CommitteeResolutionDetail() {
  return <ResolutionDetailPage basePath="/committee/polls" />
}
